package ca.northroot.app.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ca.northroot.app.ui.theme.NorthrootGold
import ca.northroot.app.ui.theme.NorthrootGray
import kotlinx.datetime.*

@Composable
fun WeekDatePicker(
    selectedDate: LocalDate,
    onDateSelected: (LocalDate) -> Unit
) {
    val weekDays = remember(selectedDate) {
        // Find the start of the week (Sunday)
        // Monday=1 ... Sunday=7 in kotlinx-datetime
        val daysToSubtract = if (selectedDate.dayOfWeek == DayOfWeek.SUNDAY) 0 else selectedDate.dayOfWeek.isoDayNumber
        val sunday = selectedDate.minus(daysToSubtract, DateTimeUnit.DAY)
        
        (0..6).map { 
            sunday.plus(it, DateTimeUnit.DAY)
        }
    }

    LazyRow(
        modifier = Modifier
            .fillMaxWidth()
            .background(MaterialTheme.colorScheme.surface)
            .padding(vertical = 8.dp),
        contentPadding = PaddingValues(horizontal = 16.dp),
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        items(weekDays) { date ->
            val isSelected = date == selectedDate
            val dayName = date.dayOfWeek.name.take(3)
            val dayNum = date.dayOfMonth.toString()

            Column(
                modifier = Modifier
                    .width(48.dp)
                    .clip(RoundedCornerShape(16.dp))
                    .background(if (isSelected) MaterialTheme.colorScheme.primary else Color.Transparent)
                    .clickable { onDateSelected(date) }
                    .padding(vertical = 12.dp),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Text(
                    dayName.uppercase(), 
                    fontSize = 10.sp, 
                    fontWeight = FontWeight.Bold, 
                    color = if (isSelected) MaterialTheme.colorScheme.onPrimary else NorthrootGray
                )
                Spacer(Modifier.height(4.dp))
                Text(
                    dayNum, 
                    fontSize = 16.sp, 
                    fontWeight = FontWeight.Black, 
                    color = if (isSelected) MaterialTheme.colorScheme.onPrimary else MaterialTheme.colorScheme.onSurface
                )
                if (isSelected) {
                    Box(Modifier.size(4.dp).clip(CircleShape).background(NorthrootGold))
                }
            }
        }
    }
}
